module.exports = __webpack_public_path__ + "img/card_230280668.e134270f.jpg";